import { useState } from 'react';
import { useSelector } from 'react-redux';
import { AgreementApiModel } from '../../../shared/models/DealModel';
import { accountSelector } from '../../../shared/store/shared/accountSlice';
import AccessRuleCard from './AccessRuleCard';
import { useGetAccessRuleQuery } from './apiSlice';

export default function AccessRulesList({ deal }: { deal: AgreementApiModel }) {
  const { currentAccountId } = useSelector(accountSelector);
  const [editingDomainName, setEditingDomainName] = useState<string | null>(
    null,
  );

  const { data: accessRules, isLoading } = useGetAccessRuleQuery({
    accountId: currentAccountId,
    providerNumber: deal.id,
  });

  if (accessRules?.length === 0 && !isLoading) {
    return null;
  }

  return (
    <div>
      {accessRules?.map((rule) => (
        <AccessRuleCard
          key={rule.domainName}
          rule={rule}
          deal={deal}
          isEditMode={editingDomainName === rule.domainName}
          onEditModeChange={(editing) =>
            setEditingDomainName(editing ? rule.domainName : null)
          }
        />
      ))}
    </div>
  );
}
